"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var bday_1 = require("./bday");
var nnn_1 = require("./nnn");
var cc = require("./cc");
var century = require("./century");
var Result = require("./result");
exports.Result = Result;
var ValidSsn = /** @class */ (function () {
    function ValidSsn(bday, nnn, control) {
        var _this = this;
        this.bday = bday;
        this.nnn = nnn;
        this.control = control;
        this.isFemale = function () { return _this.nnn.isFemale(); };
        this.isMale = function () { return _this.nnn.isMale(); };
        this.isTemporal = function () { return _this.nnn.isTemporal(); };
        this.toString = function () { return "" + _this.bday + _this.bday.toCenturyId() + _this.nnn + _this.control; };
    }
    return ValidSsn;
}());
exports.ValidSsn = ValidSsn;
// -- GENERATOR
exports.female = function (date) { return exports.generate(nnn_1.Nnn.generate(nnn_1.Gender.Female), date); };
exports.femaleTemporal = function (date) { return exports.generate(nnn_1.Nnn.generateTemporal(nnn_1.Gender.Female), date); };
exports.male = function (date) { return exports.generate(nnn_1.Nnn.generate(nnn_1.Gender.Male), date); };
exports.maleTemporal = function (date) { return exports.generate(nnn_1.Nnn.generateTemporal(nnn_1.Gender.Male), date); };
exports.generate = function (nnn, date) {
    if (date === void 0) { date = bday_1.Bday.random(); }
    var bday = bday_1.Bday.from(date);
    var control = cc.from(bday, nnn);
    return new ValidSsn(bday, nnn, control);
};
// -- PARSER
var Groups;
(function (Groups) {
    Groups[Groups["bday"] = 1] = "bday";
    Groups[Groups["century"] = 2] = "century";
    Groups[Groups["nnn"] = 3] = "nnn";
    Groups[Groups["control"] = 4] = "control";
})(Groups || (Groups = {}));
var pattern = '^' + // start
    '(.{6})' + // bday: ddMMyy
    '(.)' + // century id: - or A
    '(.{3})' + // nnn: three digits
    '(.)' + // control char
    '$'; // end
var re = new RegExp(pattern);
exports.parse = function (candidate) {
    try {
        var m = candidate.match(re);
        if (m == null) {
            throw new Error('Invalid ssn: pattern mismatch');
        }
        var centuryId = century.parseId(m[Groups.century]);
        var bday = bday_1.Bday.parse(m[Groups.bday], centuryId);
        var nnn = nnn_1.Nnn.parse(m[Groups.nnn]);
        var control = m[Groups.control];
        if (cc.from(bday, nnn) !== control) {
            throw new Error("Invalid ssn: control char mismatch");
        }
        return new ValidSsn(bday, nnn, control);
    }
    catch (e) {
        return e;
    }
};
//# sourceMappingURL=index.js.map